// This file dictates what the user will see available in the side bar
export default [
  {
    name: 'MClem',
    icon: 'ti-headphone',
    path: '/admin/overview'
  },
  // {
  //   name: 'Components',
  //   icon: 'ti-package',
  //   children: [{
  //     name: 'Buttons',
  //     path: '/components/buttons'
  //   },
  //   {
  //     name: 'Grid System',
  //     path: '/components/grid-system'
  //   },
  //   {
  //     name: 'Panels',
  //     path: '/components/panels'
  //   },
  //   {
  //     name: 'Sweet Alert',
  //     path: '/components/sweet-alert'
  //   },
  //   {
  //     name: 'Notifications',
  //     path: '/components/notifications'
  //   },
  //   {
  //     name: 'Icons',
  //     path: '/components/icons'
  //   },
  //   {
  //     name: 'Typography',
  //     path: '/components/typography'
  //   }]
  // },
  // {
  //   name: 'Forms',
  //   icon: 'ti-clipboard',
  //   children: [{
  //     name: 'Regular Forms',
  //     path: '/forms/regular'
  //   },
  //   {
  //     name: 'Extended Forms',
  //     path: '/forms/extended'
  //   },
  //   {
  //     name: 'Validation Forms',
  //     path: '/forms/validation'
  //   },
  //   {
  //     name: 'Wizard',
  //     path: '/forms/wizard'
  //   }
  //   ]
  // },
  // {
  //   name: 'Table List',
  //   icon: 'ti-view-list-alt',
  //   collapsed: true,
  //   children: [{
  //     name: 'Regular Tables',
  //     path: '/table-list/regular'
  //   },
  //   {
  //     name: 'Extended Tables',
  //     path: '/table-list/extended'
  //   },
  //   {
  //     name: 'Paginated Tables',
  //     path: '/table-list/paginated'
  //   }
  //   ]
  // },
  // {
  //   name: 'Maps',
  //   icon: 'ti-map',
  //   children: [{
  //     name: 'Google Maps',
  //     path: '/maps/google'
  //   },
  //   {
  //     name: 'Full Screen Maps',
  //     path: '/maps/full-screen'
  //   },
  //   {
  //     name: 'Vector Maps',
  //     path: '/maps/vector-map'
  //   }
  //   ]
  // },
  // {
  //   name: 'Charts',
  //   icon: 'ti-gift',
  //   path: '/charts'
  // },
  // {
  //   name: 'Calendar',
  //   icon: 'ti-calendar',
  //   path: '/calendar'
  // },
  // {
  //   name: 'Experience',
  //   icon: 'ti-clipboard',
  //   path: '/experience'
  // },
  {
    name: 'Research',
    icon: 'ti-light-bulb',
    path: '/research'
  },
  {
    name: 'Projects',
    icon: 'ti-pencil',
    children: [{
      name: 'Midi Mosaic',
      path: '/projects/midi-mosaic'
    },
    {
      name: 'Snowflake',
      path: '/projects/snowflake'
    },
    {
      name: 'Candy Cane',
      path: '/projects/candy-cane'
    },
    {
      name: 'LED Lightbox',
      path: '/projects/lightbox'
    },
    {
      name: 'Prosody',
      path: '/projects/prosody'
    },
    {
      name: 'Call of Data',
      path: '/projects/call-of-data'
    },
    {
      name: 'COVID Challenge',
      path: '/projects/covid-challenge'
    },
    {
      name: 'CBR Vocal Chain',
      path: '/projects/cbr-vocal-chain'
    },
    {
      name: 'Dance Collab',
      path: '/projects/dance-collab'
    },
    {
      name: 'AudioTreks',
      path: '/projects/soundwalk-app'
    }
    ]
  }
  // ,
  // {
  //   name: 'Pages',
  //   icon: 'ti-gift',
  //   children: [{
  //     name: 'User Page',
  //     path: '/pages/user'
  //   },
  //   {
  //     name: 'Timeline Page',
  //     path: '/pages/timeline'
  //   },
  //   {
  //     name: 'Login Page',
  //     path: '/login'
  //   },
  //   {
  //     name: 'Register Page',
  //     path: '/register'
  //   },
  //   {
  //     name: 'Lock Page',
  //     path: '/lock'
  //   }
  //   ]
  // }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js